/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Edit_Event_Group_DescriptionInputs */

const en_edit_event_group_description = /** @type {(inputs: Edit_Event_Group_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit event group settings and properties`)
};

const fr_edit_event_group_description = /** @type {(inputs: Edit_Event_Group_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modifier les paramètres et propriétés du groupe d'événements`)
};

const de_edit_event_group_description = /** @type {(inputs: Edit_Event_Group_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einstellungen und Eigenschaften der Ereignisgruppe bearbeiten`)
};

const it_edit_event_group_description = /** @type {(inputs: Edit_Event_Group_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modifica le impostazioni e le proprietà del gruppo di eventi`)
};

const ru_edit_event_group_description = /** @type {(inputs: Edit_Event_Group_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Редактирование настроек и свойств группы событий`)
};

const es_edit_event_group_description = /** @type {(inputs: Edit_Event_Group_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editar la configuración y las propiedades del grupo de eventos`)
};

const zh_cn2_edit_event_group_description = /** @type {(inputs: Edit_Event_Group_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`编辑事件组设置和属性`)
};

const ja_edit_event_group_description = /** @type {(inputs: Edit_Event_Group_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントグループの設定とプロパティを編集する`)
};

const hi_edit_event_group_description = /** @type {(inputs: Edit_Event_Group_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इवेंट समूह की सेटिंग्स और प्रॉपर्टीज़ को संपादित करें`)
};

const pt_pt2_edit_event_group_description = /** @type {(inputs: Edit_Event_Group_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editar configurações e propriedades do grupo de eventos`)
};

/**
* | output |
* | --- |
* | "Edit event group settings and properties" |
*
* @param {Edit_Event_Group_DescriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const edit_event_group_description = /** @type {((inputs?: Edit_Event_Group_DescriptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Edit_Event_Group_DescriptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_edit_event_group_description(inputs)
	if (locale === "de") return de_edit_event_group_description(inputs)
	if (locale === "it") return it_edit_event_group_description(inputs)
	if (locale === "ru") return ru_edit_event_group_description(inputs)
	if (locale === "es") return es_edit_event_group_description(inputs)
	if (locale === "zh-CN") return zh_cn2_edit_event_group_description(inputs)
	if (locale === "ja") return ja_edit_event_group_description(inputs)
	if (locale === "hi") return hi_edit_event_group_description(inputs)
	if (locale === "pt-PT") return pt_pt2_edit_event_group_description(inputs)
	return en_edit_event_group_description(inputs)
});